export default __webpack_public_path__ + "static/media/list.e39f7b54.svg";